import React from 'react';
import {FeaturesList, Grid2Columns, Item, SectionHeader} from '../utils/Styled';
import {Trans, useI18next} from 'gatsby-plugin-react-i18next';
import {MenuItemIcon} from '../utils/MenuItemIcon';
import {InternalPageLink} from 'components/links/Pages';
import {AnchorLink} from 'components/AnchorLink';
import {MenuLink, Props} from '../utils/types';
import {
  ecommercePayments,
  inPersonPayments,
  omnichannelPayments,
  paymentsSecurity,
  otherFeatures
} from '../constants/products';

export const Products: React.FC<Props> = ({itemClick}) => {
  const {language} = useI18next();
  const renderItem = (item: MenuLink, index: number) => (
    <Item key={item.slug + '-' + index}>
      <MenuItemIcon name={item.icon} />
      {item.slug ? (
        <InternalPageLink slug={item.slug} activeClassName="active" onClick={itemClick}>
          {item.title}
        </InternalPageLink>
      ) : item.to ? (
        <AnchorLink href={item.toByLanguage?.[language] || item.to} target="_blank">
          {item.title}
        </AnchorLink>
      ) : (
        item.title
      )}
    </Item>
  );

  return (
    <Grid2Columns columnWidth="250px">
      <div>
        <SectionHeader marginTop="0">
          <Trans>E-commerce payments</Trans>
        </SectionHeader>
        <FeaturesList>
          {ecommercePayments.map((item, index) => renderItem(item, index))}
        </FeaturesList>

        <SectionHeader marginTop="24px">
          <Trans>In-person payments</Trans>
        </SectionHeader>
        <FeaturesList>
          {inPersonPayments.map((item, index) => renderItem(item, index))}
        </FeaturesList>

        <SectionHeader marginTop="24px">
          <InternalPageLink
            slug="omnichannel-payments-platform"
            onClick={itemClick}
            style={{fontWeight: 600}}>
            <Trans>Omnichannel payments</Trans>
          </InternalPageLink>
        </SectionHeader>
        <FeaturesList>
          {omnichannelPayments.map((item, index) => renderItem(item, index))}
        </FeaturesList>
      </div>
      <div>
        <SectionHeader marginTop="0">
          <Trans>Payments security</Trans>
        </SectionHeader>
        <FeaturesList>
          {paymentsSecurity.map((item, index) => renderItem(item, index))}
        </FeaturesList>

        <SectionHeader marginTop="24px">
          <Trans>Other features</Trans>
        </SectionHeader>
        <FeaturesList>{otherFeatures.map((item, index) => renderItem(item, index))}</FeaturesList>
      </div>
    </Grid2Columns>
  );
};
